import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { LocationQueryCriteriaClass, LocationCriteriaModelQuery } from '../../../criteria/location-query-criteria.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiResponseModel, BasicApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { ApiVisa } from '../../shared/api-visa.model';
import { LocationContainerModel } from '../../../../../../models/aggregates/erp/location';
import { Observable } from 'rxjs';
import { Pagination } from '../../shared/pagination.model';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({
  providedIn: 'root'
})
export class LocationService extends BaseApiPublicLoginTemplateService<LocationContainerModel, LocationContainerModel, LocationContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'locations';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'locations';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'locations';
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'locations/' + BaseApiTemplateService.LOGIN_ENTITY_EP;
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'locations/' + BaseApiTemplateService.LOGIN_EP;
    this.httpClient = http;
  }

  getPromiseByCriteria(
    visa: ApiVisa, criteria?: LocationQueryCriteriaClass
  ): Observable<ApiResponseModel<LocationContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildDocCriteria = new LocationCriteriaModelQuery(criteria);
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    return this.httpClient.get<ApiResponseModel<LocationContainerModel>>
      (UrlByCriteria, this.getHttpHeader(visa));
  }

  getAllLocationForAppletLoginEp(
    appletGuid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<LocationContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<LocationContainerModel>>(
      this.apiUrl + '/basic-info/applet-login-ep/' + appletGuid,
      this.getHttpHeader(visa)
    );
  }

  public getLocationByCriteriaForAppletLoginEp(
    appletGuid: string,
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<LocationContainerModel>> {
    // console.log('get by criteria bsae-api');
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/basic-info/applet-login-ep/' + appletGuid + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<LocationContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getLocationByGuidForAppletLoginEp(
    appletGuid: string,
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<LocationContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<LocationContainerModel>>(
      this.apiUrl + '/basic-info/applet-login-ep/' + appletGuid + '/' + guid,
      this.getHttpHeader(visa)
    );
  }

  public postLocationWithLink(
    dtoObject: LocationContainerModel, 
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<LocationContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/with-links';
    }
    return this.httpClient.post<BasicApiResponseModel<LocationContainerModel>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  // /core2/tnt/dm/erp/locations/custom/query/backoffice-ep
  public getLocationsByHdrGuids(
    dtoObject: any,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<LocationContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/custom/query/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<LocationContainerModel>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
